import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../firebase/config.ts';
import { doc, getDoc } from 'firebase/firestore';
import { isAllowlistedAdminEmail } from '../config/adminAllowlist.ts';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      try {
        if (!user) {
          setIsAdmin(false);
          return;
        }
        await user.getIdToken(true);
        const uid = user.uid;
        const adminDoc = await getDoc(doc(db, 'admins', uid));
        if (cancelled) return;
        if (auth.currentUser?.uid !== uid) {
          setIsAdmin(false);
          return;
        }
        setIsAdmin(adminDoc.exists() || isAllowlistedAdminEmail(user.email));
      } catch (e) {
        console.error('ProtectedRoute: admin check failed', e);
        if (!cancelled) setIsAdmin(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}; 